import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ContentHeader } from 'widgets/NonLoggedLayout';

type Props = {
  errorLabel?: ReactNode;
  backButtonAction?: () => void;
};

export const AuthContainerLoginHeader = ({
  errorLabel,
  backButtonAction,
}: Props) => {
  const { t } = useTranslation('user');

  return (
    <ContentHeader
      title={t('login', { ns: 'user' })}
      description={t('loginDescription', { ns: 'user' })}
      errorLabel={errorLabel}
      backButtonAction={backButtonAction}
    />
  );
};
